module.exports = __webpack_public_path__ + "static/media/Twitter-X.c019bd43.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Twitter-X.png
// module id = 9
// module chunks = 0